import { HomeSpaceApiItem } from '@core/types/state';

export const moveHomeSpaceToFront = (
  spaces: HomeSpaceApiItem[],
  spaceId: string
): HomeSpaceApiItem[] | null => {
  const index = spaces.findIndex((space) => space.spaceId === spaceId);

  if (index < 0) {
    return null;
  }

  if (index === 0) {
    return spaces;
  }

  const nextSpaces = [...spaces];
  const [visitedSpace] = nextSpaces.splice(index, 1);
  nextSpaces.unshift(visitedSpace);

  return nextSpaces;
};
